<template>
  <div class="v-button-switcher" v-if="items.length">
    <div
      class="v-button-switcher__btn"
      v-for="item in items"
      :key="item.id"
      @click="$emit('switcher-select', item)"
      :class="{
        'v-button-switcher__btn--select': item.id === selectItem
      }"
    >
      {{item.name}} {{item.name_second}}
      <span class="help-text" v-show="item.price > 0"
        >{{ item.price }} ₽/л</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "vButtonSwitcher",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selectItem: {
      type: [Object, Number],
      default: null
    }
  }
};
</script>

<style scoped></style>
